import { BrokerExtensions } from "@primaria/plugins-core";
import { ResetFiltersCommand } from "./request";
import { ResetFiltersHandler } from "./handler";
import { BrokerDisposableHandler } from "@uxland/primary-shell";

let request: BrokerDisposableHandler;

export const bootstrapResetFilters = (broker: BrokerExtensions) => {
  request = broker.registerRequest(ResetFiltersCommand, ResetFiltersHandler);
};

export const teardownResetFilters = () => {
  request?.dispose();
};
